"use strict";

exports.__esModule = true;
exports.LogbookPanelThumbnail = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _class, _LogbookPanelThumbnail;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Thumbnail for LogbookPanelWidget.
 */
var LogbookPanelThumbnail = exports.LogbookPanelThumbnail = (0, _styledComponents.withTheme)(_class = (_LogbookPanelThumbnail = /*#__PURE__*/function (_Component) {
  function LogbookPanelThumbnail() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(LogbookPanelThumbnail, _Component);
  var _proto = LogbookPanelThumbnail.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      x = _this$props.x,
      y = _this$props.y,
      width = _this$props.width,
      height = _this$props.height,
      theme = _this$props.theme;
    var rowHeight = 70;
    var rowCount = Math.ceil(height / rowHeight);
    var currentY = 0;
    var cycles = [];
    for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
      var stateId = rowIndex % 2 ? "Comment" : "Ticket";
      var fill = stateId === "Ticket" ? theme.LogbookTicketFillColor : theme.LogbookCommentFillColor;
      cycles.push(/*#__PURE__*/_react["default"].createElement("rect", {
        key: rowIndex + "-color",
        x: 0,
        y: currentY,
        width: 20,
        height: rowHeight,
        fill: fill
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        key: rowIndex + "-bg",
        x: 20,
        y: currentY,
        width: width - 20,
        height: rowHeight,
        fill: "white"
      }), /*#__PURE__*/_react["default"].createElement("text", {
        key: rowIndex + "-text",
        x: 32,
        y: currentY + 32,
        width: width - 32,
        height: rowHeight,
        fontSize: "1.4rem"
      }, stateId));
      currentY += rowHeight;
    }
    return /*#__PURE__*/_react["default"].createElement("svg", {
      x: x,
      y: y,
      width: width,
      height: height
    }, cycles);
  };
  return LogbookPanelThumbnail;
}(_react.Component), _LogbookPanelThumbnail.defaultProps = {
  x: 0,
  y: 0,
  theme: undefined
}, _LogbookPanelThumbnail)) || _class;